import { useEffect as e } from "react";
import { createScriptTags as t } from "../utils/helpers.js";
const o = (r) => (e(() => {
  t(r);
}, [r]), null);
export {
  o as default
};
